import { NewbornNote } from "src/app/models/NewbornNote";
import { ContactDto } from "./contactDto";
import { SexEnum } from "src/app/enums/SexEnum";

export interface IPatient {
  Id: number;
  CId: string;
  CName: string;
  Birthday: Date;
  Sex: number;
  PatientNo: string;
}
export class PatientsDto {

  Id: number;
  IsEnable: boolean;

  ClinicId: string;
  PatientNo: string;
  IsCustomPatientNo?: boolean;
  Kcstmr: string;
  CName: string;
  MiddleName: string;
  LastName: string;
  Nickname: string;
  CId: string;
  Birthday: any;
  Sex: number;
  Country: string;
  BlRH: number;
  BlType: number;
  Married: number;
  PhoneArea: string;
  Phone: string;
  CellPhone: string;
  EMail: string;
  AddressId: number;
  MailingAddressId: number;
  FoodAllergy: string;
  DrugAllergy: string;
  DiseaseHistory: string;
  DiseaseHistoryRemark: string;
  Remark: string;
  DiscountId: number;
  //基本資料的優免整合欄位改成文字才能存多筆
  // DiscountIdRegisterFee: number;
  DiscountIdRegisterFee: string;
  DiscountCode: string;
  ICode: string;
  ZipCode: string;
  Nation: string;
  State: string;
  City: string;
  Area: string;
  Street: string;
  ResZipCode: string;
  ResCity: string;
  ResArea: string;
  ResStreet: string;
  IsSMS: boolean;
  IsAgreeMsg: boolean;
  /** 是否已加診所 LINE：null 未知、true 已加、false 未加 */
  IsLineAdded: boolean | null;
  /** 病患 LINE ID；未填為空字串 */
  LineId: string;
  IsCheckCId: boolean;
  // PatientHIS
  PatientHisId: number;
  Title: string;
  EstBirthYear: number;
  EducationCode: string;
  Family: string;
  JobCode: string;
  StatusCode: string;
  ShortNo: string;
  FirstDate: Date;
  LastDate: Date;
  LastMCDate: Date;
  DueDate: Date;
  IsPregnant: boolean;
  SpcIdentity: string;
  ChewingBetelNuts?: string;
  Smoking?: string;
  SoldierEdt: Date;
  Handicapp: string;
  MissTimes: number;
  Height: number;
  Weight: number;
  BMI: number;
  Waist: number;
  SocialInusranceNo: string;
  RaceCode: string;
  MSTS: number;
  PaySysA: string;
  Contacts: ContactDto[];
  IsAlive: boolean;
  CanDelete: boolean = true;
  SupArea: string;
  DxCertRemark: string;
  Job: string;
  BirthCity: string;
  PrintName: string;
  EName: string;
  EAddress: string;
  Name: string;
  BirthsNum?: number;
  MonParentsNo?: string;
  RemarkOne?: string;
  FirstDialysisDate: Date;
  MajorInjuryTimes: number;
  MajorInjuryDate: Date;
  MajorInjuryEndDate?: Date;
  NeedToCheckCName?: boolean = true;
}

export class QueryPatient {
  Found: boolean;
  PatientName: string;
  PatientCId: string;
}

/** 基資列印 */
export class PatientBasicPrint {
  PatientNo: string;
  CName: string;
  Sex: string;
  ICode: string;
  CId: string;
  Birthday: Date | string;
  BlType: string;
  BlRH: string;
  Phone: string;
  CellPhone: string;
  contactName?: string;
  contactOnePhone?: string;
  contactOneMobile?: string;
  JobCode: string;
  EducationCode: string;
  FirstDate: Date | string;
  Height: number;
  Weight: number;
  DrugAllergy: string;
  Remark: string;
  clinicName: string;
  patientAddress: string;
  contactsAddress: string;
  relation: string;
}

export interface NewBornCreateDto {
  NewbornNote: Partial<NewbornNote>;
  Patient: Partial<PatientsDto>;
}

export interface NewbornViewDto {

  Id: number;
  PatientMastId: number;
  Name: string;
  PatientNo: string;
  Sex: SexEnum;
  Birth: Date;
  BirthsNum: number;
}


export class FamilyInfoDto {
  ZipCode: string;

  City: string;

  Area: string;

  Street: string;

  ResZipCode: string;

  ResCity: string;

  ResArea: string;

  ResStreet: string;
}
